import React from 'react';
import { IProps } from './types';

const BgImage: React.FC<IProps> = (props) => {
  return (
    <div
      className={props.className}
      style={{
        backgroundImage: `url(${props.imageUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: props.keepRatio ? 'contain' : '100% 100%', // contain: 維持比例, 100% 100%: 變形填滿
        backgroundPosition: 'center',
        width: '100%',
        height: '100%'
      }}
    />
  );
};

export default BgImage;
